import { DaOffer } from './types';

const topNavOffersFixture: Record<string, { offers: DaOffer[] }> = {
  videobanner: {
    offers: [
      {
        offerGuid: '',
        realEstateId: '',
        offerName: '',
        asset: {
          payloadJson: 'plz use new field creative, payloadJson is deprecated!',
          dynamicParams: {},
          creative: {
            creativeType: 'videobanner',
            videobanner: {
              mobile: {},
              desktop: {
                ctaURL: 'https://www.example.org',
                ctaText: 'Sell Now!',
                videoURL:
                  'https://video.wixstatic.com/video/5e821a_a8534c15bb2c4ea3ab253179c25af5d9/360p/mp4/file.mp4',
              },
            },
          },
        },
      },
    ],
  },
  'complexbanner100%-316px': {
    offers: [
      {
        offerGuid: '',
        realEstateId: '',
        offerName: '',
        asset: {
          payloadJson: 'plz use new field creative, payloadJson is deprecated!',
          dynamicParams: {},
          creative: {
            creativeType: 'complexbanner',
            complexbanner: {
              mobile: {},
              desktop: {
                cta: {
                  url: 'https://www.example.org',
                },
                backgroundImageDark:
                  'https://wixmp-2c8f906a62709a387faa1da5.wixmp.com/banner-images/ce6eb5e4-7d6b-40cc-b629-fafe158d2181.png',
                backgroundImageLight:
                  'https://wixmp-2c8f906a62709a387faa1da5.wixmp.com/banner-images/ce6eb5e4-7d6b-40cc-b629-fafe158d2181.png',
                backgroundImageGreen:
                  'https://wixmp-2c8f906a62709a387faa1da5.wixmp.com/banner-images/ce6eb5e4-7d6b-40cc-b629-fafe158d2181.png',
              },
            },
          },
        },
      },
    ],
  },
  'complexbanner100px-54px': {
    offers: [
      {
        offerGuid: '',
        realEstateId: '',
        offerName: '',
        asset: {
          payloadJson: 'plz use new field creative, payloadJson is deprecated!',
          dynamicParams: {},
          creative: {
            creativeType: 'complexbanner',
            complexbanner: {
              mobile: {},
              desktop: {
                cta: {
                  url: 'https://www.example.org',
                },
                backgroundImageDark: 'http://picsum.photos/100/54?1',
                backgroundImageLight: 'http://picsum.photos/100/54?2',
                backgroundImageGreen: 'http://picsum.photos/100/54?3',
              },
            },
          },
        },
      },
    ],
  },
  complexbanner: {
    offers: [
      {
        offerGuid: '',
        realEstateId: '',
        offerName: '',
        asset: {
          payloadJson: 'plz use new field creative, payloadJson is deprecated!',
          dynamicParams: {},
          creative: {
            creativeType: 'complexbanner',
            modal: {
              mobile: {
                iframeContent: 'complexbanner',
              },
              desktop: {
                iframeContent: 'complexbanner',
                width: '600px',
                height: '400px',
              },
            },
            adhesion: {
              mobile: {
                bannerURL: 'asdasdasdasd',
                bannerImage: 'http://picsum.photos/320/50?1',
                bannerImageHover: 'http://picsum.photos/320/50',
              },
              desktop: {
                bannerURL: 'asdasdasdasd',
                bannerImage: 'http://picsum.photos/970/90?1',
                bannerImageHover: 'http://picsum.photos/970/90',
              },
            },
            complexbanner: {
              mobile: {
                cta: {
                  label: 'dasd',
                  url: 'sdasd',
                  color: '#ADADAD',
                  backgroundColor: '#AAAAAA',
                },
                fontSize: 'small',
                align: 'center',
                valign: 'middle',
                title: 'asdasd',
                description: 'asdasdas',
                titleColor: '#DDDDDD',
                bodyColor: '#AAAAAA',
                backgroundColor: '#DDDDDD',
                countdownTimer: 2147483647,
                headerImage: 'http://picsum.photos/1000/1000',
                backgroundImageDark: 'http://picsum.photos/1000/1000',
                backgroundImageLight: 'http://picsum.photos/1000/1000',
                backgroundImageGreen: 'http://picsum.photos/1000/1000',
              },
              desktop: {
                cta: {
                  label: 'dasd',
                  url: 'sdasd',
                  color: '#ADADAD',
                  backgroundColor: '#AAAAAA',
                },
                fontSize: 'small',
                align: 'center',
                valign: 'middle',
                title: 'asdasd',
                description: 'asdasdas',
                titleColor: '#DDDDDD',
                bodyColor: '#AAAAAA',
                backgroundColor: '#DDDDDD',
                countdownTimer: 2147483647,
                headerImage: 'http://picsum.photos/1000/1000',
                backgroundImageDark: 'http://picsum.photos/1000/1000',
                backgroundImageLight: 'http://picsum.photos/1000/1000',
                backgroundImageGreen: 'http://picsum.photos/1000/1000',
              },
            },
          },
        },
      },
    ],
  },
  adhesion: {
    offers: [
      {
        offerGuid: 'd5857f72-03da-4b41-8f1f-99949315ca7f',
        realEstateId: '166926a9-15ab-458d-b424-4385d5c9acde',
        offerName: 'Dan Test',
        asset: {
          payloadJson: 'plz use new field creative, payloadJson is deprecated!',
          dynamicParams: {},
          creative: {
            modal: {
              mobile: {
                iframeContent: 'complexbanner',
              },
              desktop: {
                iframeContent: 'complexbanner',
              },
            },
            adhesion: {
              mobile: {},
              desktop: {
                bannerURL:
                  'https://play.google.com/store/apps/details?id=com.deviantart.android.damobile&hl=en_US&gl=US',
                bannerImage:
                  'https://wixmp-70a14ff54af6225c7974eec7.wixmp.com/offers-assets/cb18a5af-5d21-480e-8633-97b5119e30e8.png',
                bannerImageHover:
                  'https://wixmp-70a14ff54af6225c7974eec7.wixmp.com/offers-assets/fadb9b80-d071-4879-ad3b-a31732a57234.png',
              },
            },
            creativeType: 'adhesion',
            complexbanner: {
              mobile: {
                cta: {},
                align: 'center',
                valign: 'middle',
                fontSize: 'small',
              },
              desktop: {
                cta: {},
                align: 'center',
                valign: 'middle',
                fontSize: 'small',
              },
            },
          },
        },
        startDate: '2023-11-21T01:57:06.776Z',
      },
    ],
  },
  modal: {
    offers: [
      {
        offerGuid: '',
        realEstateId: '',
        offerName: '',
        asset: {
          payloadJson: 'plz use new field creative, payloadJson is deprecated!',
          dynamicParams: {},
          creative: {
            creativeType: 'modal',
            banner: {
              mobile: {
                bannerImage: 'http://picsum.photos/300/400',
              },
              desktop: {
                bannerURL: 'https://www.example.org',
                bannerImage: 'http://picsum.photos/500/400',
                bannerImageHover: 'http://picsum.photos/500/400',
              },
            },
            modal: {
              mobile: {
                iframeContent: 'banner',
              },
              desktop: {
                iframeContent: 'banner',
                width: '500',
                height: '400',
              },
            },
          },
        },
      },
    ],
  },
  modalvid: {
    offers: [
      {
        offerGuid: '',
        realEstateId: '',
        offerName: '',
        asset: {
          payloadJson: 'plz use new field creative, payloadJson is deprecated!',
          dynamicParams: {},
          creative: {
            creativeType: 'modal',
            videobanner: {
              mobile: {},
              desktop: {
                ctaURL: '',
                ctaText: '',
                videoURL:
                  'https://video.wixstatic.com/video/5e821a_a8534c15bb2c4ea3ab253179c25af5d9/360p/mp4/file.mp4',
              },
            },
            modal: {
              mobile: {
                iframeContent: 'videobanner',
              },
              desktop: {
                iframeContent: 'videobanner',
                width: '600',
                height: '350',
              },
            },
          },
        },
      },
    ],
  },
};

export { topNavOffersFixture };
